import Vue from 'vue'

import ApiRequest from '@/services/ApiRequests/ApiRequest'
import ClientRequestApi from '@/services/Api/ClientRequestApi'
import clientRequestsClient from '@/services/ClientRequestsClient'

const unreadClientRequestCountApiRequest = new ApiRequest(ClientRequestApi.fetchTotalCountOfUnreadRequests)
const fetchCountOfUnreadForexRequests = new ApiRequest(ClientRequestApi.fetchCountOfUnreadForexRequests)

const state = () => ({
  requestsCount: 0,
  forexCount: 0
})

const getters = {
  requestStatusOptions () {
    return Object.keys(REQUEST_STATUSES).map(
      requestStatus => ({
        name: REQUEST_STATUSES[requestStatus],
        value: REQUEST_STATUSES[requestStatus]
      })
    )
  },
  unreadClientRequestTotalCount (state) {
    return state.requestsCount
  },
  unreadForexTotalCount (state) {
    return state.forexCount
  }
}

const actions = {
  getClientRequest ({ commit }, id) {
    return clientRequestsClient.sendRequest(
      'GET',
      `api/v1/admin/profiles/${id.profileId}/requests/${id.seq}`,
      { messages: true }
    )
      .then(response => response.payload)
  },
  loadUnreadClientRequestCount ({ commit }) {
    return unreadClientRequestCountApiRequest.execute()
      .then(({ count }) => commit('setUnreadRequestsCount', count))
      .catch(() => {})
  },
  cancelLoadUnreadClientRequests () {
    return unreadClientRequestCountApiRequest.cancel()
  },
  loadUnreadForexClientRequestCount ({ commit }) {
    return fetchCountOfUnreadForexRequests.execute()
      .then(({ count }) => commit('setUnreadForexCount', count))
      .catch(() => {})
  },
  cancelLoadForexUnreadClientRequests () {
    return fetchCountOfUnreadForexRequests.cancel()
  },
  markAsReadClientRequest (context, id) {
    return clientRequestsClient.sendRequest(
      'PUT',
      `api/v1/admin/profiles/${id.profileId}/requests/${id.seq}/read`
    )
  }
}

const mutations = {
  setUnreadRequestsCount (state, count) {
    Vue.set(state, 'requestsCount', count)
  },
  setUnreadForexCount (state, count) {
    Vue.set(state, 'forexCount', count)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export const REQUEST_STATUSES = {
  PENDING: 'PENDING',
  DONE: 'DONE',
  CANCELED: 'CANCELED',
  ANSWERED: 'ANSWERED'
}
